import {DefaultResType, ErrorType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {OcSearchParamType} from "../../pages/main/overseasCorporation/list/interface";

const url = "api/home/overseas/";

export async function readOverseas(param: OcSearchParamType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_overseas", param);
    } catch (err: any) {
        return err?.response;
    }
}

export async function readExchangeRateForPeriod(param: {
    startAt: string
    endAt: string
}): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_exchange_rate_for_period", param);
    } catch (err: any) {
        return err?.response;
    }
}

export async function updateExchangeRate(
    param: OcSearchParamType & { overseasReqList: { overseasId: number }[] }
): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_exchange_rate", param);
    } catch (err: any) {
        return err?.response;
    }
}

export async function uploadOverseasExcel(data: FormData): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "upload_overseas_excel", data, {headers: {"Content-Type": "multipart/form-data"}});
    } catch (err: any) {
        return err?.response;
    }
}

export async function exportOverseasExcel(param: OcSearchParamType): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
    const response = await baseApi.post(url + "export_overseas_excel", param, {
        responseType: "blob",
    });

    return response?.data;
}

export async function exportOverseasStandardFormExcel(data: OcSearchParamType): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
    const response = await baseApi.post(url + "export_overseas_standard_form_excel", data, {
        responseType: "blob",
    });

    return response?.data;
}

export async function readOverseasColumnSetting(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_overseas_column_setting");
    } catch (err: any) {
        return err?.response;
    }
}

export async function updateOverseasColumnSetting(data: {
    isHidden: string,
    overseasViewInfoId: number
}[]): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_overseas_column_setting", data);
    } catch (err: any) {
        return err?.response;
    }
}